module.exports = __webpack_public_path__ + "static/media/Logo-BNI-46.53bbeca5.png";